import { FormControlLabel, Checkbox } from "@mui/material";
import { useTheme } from "../../util/themes";

export const NewsletterCheckbox: React.FC<{
  checked: boolean;
  onChange: (checked: boolean) => void;
}> = ({ checked, onChange }) => {
  const theme = useTheme();

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          sx={{
            color: theme.colors.text.secondary,
            '&.Mui-checked': {
              color: theme.colors.text.primary,
            },
          }}
        />
      }
      label="Quiero recibir ofertas y novedades por e-mail"
      sx={{
        '& .MuiTypography-root': {
          fontFamily: '"Rubik", sans-serif',
          fontSize: '14px',
          color: theme.colors.text.primary,
        }
      }}
    />
  );
};














